import { Component } from "react";
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../utils/withRouter";
import moment from "moment";
import { connect } from "react-redux";
import Pagination from "../../utils/pagination";
import {
  sessionExpireMessage,
  toastError,
  tokenInavlidMessage,
} from "../../utils/constants";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { fill_action } from "../../actions/fillCombo_action";
import * as XLSX from 'sheetjs-style';
import Header from "../../common_components/Header";
import { get_report_details_action, get_dynamic_report_action, get_dynamic_fillList_action } from "../../actions/report_action/report_action";
import Footer from "../../common_components/Footer";

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderColor: "#c9c9c9",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#80bdff",
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    borderRadius: "14px",
    padding: "4px",
    backgroundColor: "#00BCD4",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "white",
    fontSize: "12px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "white",
    "&:hover": {
      backgroundColor: "#00BCD4",
      color: "#fff",
    },
  }),
};
class reportGenerator extends Component {
  // intialize constructor
  constructor(props) {
    super(props);
    this.state = {
      reportName: "",
      report_id: "",
      reportParamList: [],
      reportList: [],
      venueList: [],
      venueId: "",
      venueName: "",
      isLoading: false,
      showTable: false,
      isAccordionExpanded: false,
      startDate: "",
      endDate: "",
      list: [],
      columnArr: [],
      rowArr: [],
      xlrowArr: [],
      currentPage: 1,
      recordsPerPage: 25,
      report_sp: '',
      cmsMenuData: [], cmsFooterData: [],
      isFilterShow: false,
    };

    this.updateItem = this.updateItem.bind(this);
    this.updateRecordsPerPage = this.updateRecordsPerPage.bind(this);

  }

  componentDidMount() {

    if (!JSON.parse(sessionStorage.getItem("loginDataSS"))) {
      setTimeout(() => {
        this.props.navigate('/');
      }, 200);
      return;
    }
    window.scrollTo(0, 0);

    this.setState({
      reportName:
        this.props.location.state != null &&
          this.props.location.state.reportName != null
          ? this.props.location.state.reportName
          : "",
      report_id:
        this.props.location.state != null &&
          this.props.location.state.report_id != null
          ? this.props.location.state.report_id
          : "",
    }, () => this.getReportDtl());
  }
  async getReportDtl() {
    const { report_id } = this.state;
    this.setState({ isLoading: true });

    try {
      const data = await this.props.get_report_details_action(report_id);
      this.setState({ isLoading: false });

      if (data.error !== 1) {
        console.log(data.data, 'report');

        this.setState({
          reportParamList: data.data,
          report_sp: data?.data?.[0]?.report_sp
        }, () => this.getDynamicReport());

        data.data.forEach((param) => {
          if (param.ParameterSP) {
            this.getDynamicFillList(param.ParameterSP);
          }
        });

      } else {
        if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
          //after session expire.....................
          sessionStorage.clear();
          this.props.navigate("/");
          setTimeout(() => {
            toastError(data.msg);
          }, 2000);
        } else {
          toastError(data.data);
        }
        this.setState({ isLoading: false })
        toastError(data.data.ErrorMsg);
      }
    } catch (err) {
      this.setState({ isLoading: false });
      console.log(err);
    }
  }

  getDynamicReport(selectedParams) {
    const { report_sp } = this.state;
    this.setState({ isLoading: true })
    this.props.get_dynamic_report_action(report_sp, selectedParams)
      .then((data) => {
        this.setState({ isLoading: false })
        if (data.error != 1) {
          console.log(data.data, 'report')
          this.setState({
            isLoading: false, reportList: data.data
          })
        }
        else {
          this.setState({ isLoading: false })
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/");
            setTimeout(() => {
              toastError(data.msg);
            }, 2000);
          } else {
            toastError(data.data);
          }
          this.setState({ isLoading: false })
          toastError(data.data.ErrorMsg);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })

        console.log(err)
      })
  }
  getDynamicFillList(parameterSP) {
    this.setState({ isLoading: true });

    this.props.get_dynamic_fillList_action(parameterSP)
      .then((data) => {
        this.setState({ isLoading: false });

        if (data.error !== 1) {
          console.log(data.data, 'dynamic fill list for', parameterSP);

          this.setState((prevState) => ({
            DynamicFillList: {
              ...prevState.DynamicFillList,
              [parameterSP]: data.data,
            },
          }));
        } else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/");
            setTimeout(() => {
              toastError(data.msg);
            }, 2000);
          } else {
            toastError(data.data);
          }
          this.setState({ isLoading: false })
          toastError(data.data.ErrorMsg);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log(err);
      });
  }

  handleExport() {
    const { reportParamList, reportList } = this.state;
    const reportType = reportParamList[0]?.report_type_id;

    if (reportType === 3 && reportList?.length > 0) {
      const filteredList = reportList?.map(({ jury_id, ...rest }) => rest);

      const worksheet = XLSX.utils.json_to_sheet(filteredList);

      // Auto column widths
      const cols = Object.keys(filteredList?.[0]).map(key => ({
        wch: Math.max(key?.length, ...filteredList?.map(row => String(row[key] || '')?.length)) + 2,
      }));
      worksheet['!cols'] = cols;

      // Add borders and bold headers
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!worksheet[cellAddress]) continue;

        worksheet[cellAddress].s = {
          font: { bold: true },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } },
          },
        };
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
      XLSX.writeFile(workbook, 'report.xlsx');
    } else {
      alert('No data to export or invalid report type.');
    }
  }


  onViewClick() {
    const { selectedValues, reportParamList } = this.state;

    for (let filter of reportParamList) {
      const paramName = filter.parameter_name.replace("@", "");
      const selectedValue = selectedValues?.[paramName];

      const isEmpty =
        selectedValue === undefined ||
        selectedValue === null ||
        selectedValue === "" ||
        (Array.isArray(selectedValue) && selectedValue.length === 0);

      if (filter.is_mandatory == 1 && isEmpty) {
        toastError(`Please Enter ${filter.Parameter_display_name}`);
        return; // stop further execution
      }
    }

    // All validations passed
    this.getDynamicReport(selectedValues);
  }
  navigateReportList() {
    this.props.navigate('/reportList')
  }
  renderTable(currentList) {
    console.log(currentList, 'currentList');

    if (!currentList || currentList?.length === 0) {
      return (
        <div className="table-responsive mb-4">
          <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
            <thead>
              <tr><th>No Data</th></tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ textAlign: "center" }}>Record not found</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    const excludeFields = [
      'jury_id', 'user_id', 'is_active', 'created_by_id', 'created_by_user',
      'created_date', 'modified_by_id', 'modified_by_user', 'modified_date',
      'deleted_by_id', 'deleted_by_user', 'deleted_date', 'seq_no',
      'profile_image', 'profile_filepath'
    ];

    const headers = Object.keys(currentList[0]).filter(
      (key) =>
        !excludeFields.includes(key) && !key.toLowerCase().includes('id')
    );

    return (
      <div className="table-responsive mb-4">
        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
          <thead>
            <tr>
              {headers.map((header) => (
                <th key={header}>
                  {header
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentList.map((row, i) => (
              <tr key={i}>
                {headers.map((key) => {
                  const value = row[key];
                  const formattedValue =
                    typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value)
                      ? moment(value).format("DD-MM-YYYY")
                      : value;

                  return <td key={key}>{formattedValue}</td>;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  updateItem(item) {
    this.setState({ currentPage: item });
  }
  updateRecordsPerPage = (count) => {
    this.setState({ recordsPerPage: count, currentPage: 1 }, () => window.scrollTo(0, 0));
  };

  handleback() {
    this.props.navigate("/reportParamList");
  }
  toggleFilterCollapse() {
    this.setState((prevstate) => ({
      isFilterShow: !prevstate.isFilterShow
    }))
  }
  render() {
    const {
      isLoading,
      rowArr,
      isAccordionExpanded,
      currentPage,
      showTable,
      xlrowArr,
      columnArr, isFilterShow,
      list, reportParamList, reportList, DynamicFillList, cmsMenuData, cmsFooterData, recordsPerPage,
    } = this.state;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = reportList?.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(reportList?.length / recordsPerPage);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <Header headerNavs={cmsMenuData} />
        <section class="registration_form">
          <div class="container">
            <div class="row mt-15">
              <section className="table_section">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-sm-12 col-lg-12">
                      <div className="card shadow-none border mb-2" >
                        <div className="card-header py-1">
                          <h6 className='pt-2' style={{ float: 'left' }}><a title="Back" style={{ color: 'blue' }} onClick={() => this.navigateReportList()}>Report </a> - {reportParamList?.[0]?.ReportName}</h6>
                          {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') ? <>
                            <a style={{ float: 'right' }}
                              href="javascript:void(0);"
                              className="btn btn-purple custom_btn"
                              title="Filter"
                              data-toggle="modal"
                              data-target="#filter_modal"
                              onClick={() => this.toggleFilterCollapse()}
                            >
                              <i className="fa fa-filter" />
                            </a>
                            <div
                              className="save-can d-block p-0"
                              role="group"
                              aria-label="Basic example"
                            >
                            </div>
                          </> : <></>}
                        </div>
                        <ul className="list-group list-group-flush">
                          {isFilterShow && <>
                            <li className="list-group-item" >
                              <div className="row">
                                {reportParamList?.length > 0 &&
                                  reportParamList.map((filters, index) => {
                                    const paramName = filters.parameter_name.replace("@", "");
                                    const selectedValue = this.state.selectedValues?.[paramName];

                                    let actualSP = filters.ParameterSP || "";
                                    if (typeof actualSP === "string") {
                                      Object.keys(this.state.selectedValues || {}).forEach((key) => {
                                        const placeholder = `@${key}`;
                                        const value = this.state.selectedValues[key];

                                        let replacedValue;
                                        if (Array.isArray(value)) {
                                          // Handle multiselect as comma separated
                                          replacedValue = value.map((v) => v.value || v).join(",");
                                        } else if (typeof value === "string" || typeof value === "number") {
                                          replacedValue = value;
                                        } else {
                                          replacedValue = "null";
                                        }

                                        actualSP = actualSP.replace(placeholder, replacedValue || "null");
                                      });
                                    }

                                    const rawOptions = this.state.DynamicFillList?.[actualSP] || [];
                                    const options = rawOptions.map((item) => ({
                                      Value: item.code || item.Value,
                                      Display: item.description || item.Display,
                                    }));

                                    return (<>
                                      {filters.control_type != 'session' && <>
                                        <div class="col-md-2" key={index}>
                                          <div class="form-group">
                                            <label>
                                              {filters.Parameter_display_name}
                                              {filters.is_mandatory === "1" && (
                                                <span style={{ color: "red" }}>*</span>
                                              )}
                                            </label>


                                            {/* SINGLE SELECT */}
                                            {filters.control_type === "singleselect" && (
                                              <select
                                                className="form-select"
                                                name={paramName}
                                                value={selectedValue || ""}
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  this.setState(
                                                    (prev) => ({
                                                      selectedValues: {
                                                        ...prev.selectedValues,
                                                        [paramName]: value,
                                                      },
                                                    }),
                                                    () => {
                                                      // Cascade child
                                                      if (filters.child_id && filters.child_id !== "0") {
                                                        const childParam = reportParamList.find(
                                                          (p) => p.parameter_name === filters.child_id
                                                        );

                                                        if (childParam && childParam.ParameterSP) {
                                                          let newSP = childParam.ParameterSP;

                                                          Object.keys(this.state.selectedValues || {}).forEach((key) => {
                                                            const placeholder = `@${key}`;
                                                            let replaceVal = this.state.selectedValues[key] || "null";
                                                            if (Array.isArray(replaceVal)) {
                                                              replaceVal = replaceVal.map((v) => v.value || v).join(",");
                                                            }
                                                            newSP = newSP.replace(placeholder, replaceVal);
                                                          });

                                                          this.getDynamicFillList(newSP);
                                                        }
                                                      }
                                                    }
                                                  );
                                                }}
                                              >
                                                <option value="">Select</option>
                                                {options.map((opt, i) => (
                                                  <option key={i} value={opt.Value}>
                                                    {opt.Display}
                                                  </option>
                                                ))}
                                              </select>
                                            )}

                                            {/* MULTI SELECT */}
                                            {filters.control_type === "multiselect" && (
                                              <Select
                                                isMulti
                                                name={paramName}
                                                options={options.map((opt) => ({
                                                  value: opt.Value,
                                                  label: opt.Display,
                                                }))}
                                                styles={customStyles}
                                                closeMenuOnSelect={false}
                                                value={this.state.selectedValues?.[paramName]}
                                                onChange={(selected) => {
                                                  this.setState(
                                                    (prev) => ({
                                                      selectedValues: {
                                                        ...prev.selectedValues,
                                                        [paramName]: selected,
                                                      },
                                                    }),
                                                    () => {
                                                      // Cascade child
                                                      if (filters.child_id && filters.child_id !== "0") {
                                                        const childParam = reportParamList.find(
                                                          (p) => p.parameter_name === filters.child_id
                                                        );

                                                        if (childParam && childParam.ParameterSP) {
                                                          let newSP = childParam.ParameterSP;

                                                          Object.keys(this.state.selectedValues || {}).forEach((key) => {
                                                            const placeholder = `@${key}`;
                                                            let replaceVal = this.state.selectedValues[key] || "null";
                                                            if (Array.isArray(replaceVal)) {
                                                              replaceVal = replaceVal.map((v) => v.value || v).join(",");
                                                            }
                                                            newSP = newSP.replace(placeholder, replaceVal);
                                                          });

                                                          this.getDynamicFillList(newSP);
                                                        }
                                                      }
                                                    }
                                                  );
                                                }}
                                              />
                                            )}

                                            {/* TEXT INPUT */}
                                            {filters.control_type === "text" && (
                                              <input
                                                type="text"
                                                className="form-control"
                                                maxLength={50}
                                                value={this.state.selectedValues?.[paramName] || ""}
                                                onChange={(e) => {
                                                  this.setState((prev) => ({
                                                    selectedValues: {
                                                      ...prev.selectedValues,
                                                      [paramName]: e.target.value,
                                                    },
                                                  }));
                                                }}
                                              />
                                            )}
                                            {filters.control_type === "datepicker" && (
                                              <input
                                                type="date"
                                                className="form-control"
                                                maxLength={50}
                                                value={this.state.selectedValues?.[paramName] || ""}
                                                onChange={(e) => {
                                                  this.setState((prev) => ({
                                                    selectedValues: {
                                                      ...prev.selectedValues,
                                                      [paramName]: e.target.value,
                                                    },
                                                  }));
                                                }}
                                              />
                                            )}
                                            {filters.control_type === "daterange" && (
                                              <input
                                                type="date"
                                                className="form-control"
                                                maxLength={50}
                                                value={this.state.selectedValues?.[paramName] || ""}
                                                onChange={(e) => {
                                                  this.setState((prev) => ({
                                                    selectedValues: {
                                                      ...prev.selectedValues,
                                                      [paramName]: e.target.value,
                                                    },
                                                  }));
                                                }}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </>}
                                    </>
                                    );
                                  })}
                                <div class="col-md-2">
                                  <div class="form-group">
                                    <label>&nbsp;</label>
                                    <button
                                      className="btn btn-outline-info shadow-sm w-auto p-1 px-3"

                                      onClick={() => this.onViewClick()}
                                    >
                                      View
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </>}

                        </ul>
                      </div>
                      <div className="card shadow-none border">
                        <div className="card-body  p-2 pb-0">
                          {reportParamList?.length > 0 ? reportParamList?.map((filters) => {
                            const paramName = filters?.parameter_name?.replace("@", "");
                            const rawOptions = DynamicFillList?.[filters?.ParameterSP] || [];
                            const selectedValue = this.state.selectedValues?.[paramName];

                            let displayValue = '';

                            if (Array.isArray(selectedValue)) {
                              displayValue = selectedValue.map(val => val.label || val.value).join(', ');
                            } else if (typeof selectedValue === 'object' && selectedValue !== null) {
                              displayValue = selectedValue.label || selectedValue.value;
                            } else {
                              displayValue = rawOptions.find(opt => opt.Value == selectedValue)?.Label || selectedValue;
                            }
                            console.log(selectedValue, 'selecteddddddddd')
                            return (
                              <>
                                {(selectedValue) && (
                                  <p>
                                    {filters.Parameter_display_name}:
                                    <span style={{ marginLeft: '10px', fontWeight: 'normal', color: '#555' }}>
                                      {displayValue}
                                    </span>
                                  </p>
                                )}
                              </>
                            );
                          }) : null}
                          {reportList?.length > 0 && <>
                            <button
                              className="btn btn-outline-success   shadow-sm  w-auto p-1 px-3 mx-2"
                              onClick={() => this.handleExport()}
                            >
                              Download
                            </button>
                          </>}
                          <div className="custom_table">
                            <div className="hack1">
                              <div className="hack2">
                                {this.renderTable(currentRecords)}
                                {reportList?.length > 0 ? (
                                  <Pagination
                                    nPages={nPages}
                                    currentPage={currentPage}
                                    setCurrentPage={this.updateItem}
                                    totalRecords={reportList.length}
                                    pageLength={recordsPerPage}
                                    setPageLength={this.updateRecordsPerPage}
                                  />
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>

        <Footer footerData={cmsFooterData} />

      </>
    );
  }
}

export default withRouter(
  connect(null, { fill_action, get_report_details_action, get_dynamic_report_action, get_dynamic_fillList_action })(reportGenerator)
);
